export default __webpack_public_path__ + "static/media/1954-desktop.80225de3.jpg";